export interface ILanguageState {
  selectedLanguage: string;
  keys: { [key: string]: any | undefined } | null;
}

export const INITIAL_STATE: ILanguageState = {
  selectedLanguage: 'ES',
  keys: null
};
